import React, { useState } from "react";
import { cn } from "../../utils/helper/common.helper";
import HomeMenu from "../Layout/Menu/Home";
import CheckMic from "./CheckMic";
import "./welcome.scss";

const NewWelcome = () => {
  const darkMode = localStorage.getItem("darkMode") ?? "dark";

  const [userInfo, setUserInfo] = useState(
    localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : {}
  );

  return (
    <div className={
      cn(
        "container-fluid welcome p-0",
        darkMode === "dark" ? "welcome-dark" : "welcome-light"
      )

    }>
      <HomeMenu />

      <div className="intro d-flex align-items-center ">
        <div className="container">
          <p className="h2 title">Hello {userInfo.userName}</p>
          <p className="detail">
            Bạn hãy nói và ấn Nghe lại để kiểm tra xem micro của bạn hoạt động
            tốt không nhé
          </p>

          <CheckMic />
        </div>
      </div>
    </div>
  );
};

export default NewWelcome;
